import { parseDate } from "../utils";

function getOptionsInterfaces(names) {
  if (names.indexOf("Access") > -1) {
    let ifNamesOrdered = names.filter(
      (name) => name != "Access" && name != "Internet"
    );
    ifNamesOrdered.unshift("Internet");
    ifNamesOrdered.unshift("Access");
    return ifNamesOrdered;
  } else {
    return names;
  }
}

export const parseStatsInterfacesData = (
  response,
  period,
  extPortName,
  initialRange
) => {
  if (response === "") {
    return {
      names: [],
      dataSets: {},
      options: ["All"],
    };
  }
  const rows = response.trim(/\s/).split("\n");
  const { from: beginRange, to: endRange } = initialRange;
  const { namesTotal, dataSets } = rows.reduce(
    (acc, value) => {
      const attrs = value.split(/\s+/);
      const time = parseDate(attrs[0]);

      if (time === null) {
        if (!acc.hdr) {
          const names = attrs.reduce((namesAcc, namesValue) => {
            if (namesValue) {
              const nName = !extPortName[namesValue]
                ? namesValue
                : extPortName[namesValue];
              namesAcc.push(nName);
            }
            return namesAcc;
          }, []);
          acc.names = names;
          acc.hdr = true;
          acc.namesTotal = new Set([...[...acc.namesTotal], ...names]);
        } else {
          acc["hdr"] = false;
        }
      } else {
        if (beginRange < time && time < endRange) {
          const { names } = acc;
          const emptyNames = [...acc.namesTotal].filter(
            (name) => !names.includes(name)
          );

          for (let j = 0; j < names.length; j++) {
            const Tx =
              attrs[j * 2 + 1] === "n/a" ? null : Number(attrs[j * 2 + 1]);
            const Rx =
              attrs[j * 2 + 2] === "n/a" ? null : Number(attrs[j * 2 + 2]);
            const isZeroOrNull =
              Tx === null || (Tx === 0 && Rx === null) || Rx === 0;
            const newEntry = { Tx, Rx, time };
            if (!acc.dataSets[names[j]]) {
              acc.dataSets[names[j]] = {
                items: [...acc.emptyDataset, newEntry],
                isZeroOrNull,
              };
            } else {
              acc.dataSets[names[j]].items.push(newEntry);
              if (!isZeroOrNull) {
                acc.dataSets[names[j]].isZeroOrNull = false;
              }
            }
          }

          const empty = { Tx: null, Rx: null, time };
          acc.emptyDataset.push(empty);

          emptyNames.forEach((name) => {
            if(acc.dataSets[name]?.items){
              acc.dataSets[name].items.push(empty);
            }
          });
        }
      }
      return acc;
    },
    {
      hdr: false,
      names: [],
      namesTotal: new Set([]),
      dataSets: {},
      emptyDataset: [],
    }
  );

  const options = getOptionsInterfaces([...namesTotal]);

  return {
    names: [...namesTotal],
    dataSets: dataSets || {},
    options: ["All", ...options],
  };
};

export const parseWire = (response) => {
  const [header, ...rows] = response.trim(/\s/).split("\n");
  return rows.reduce((acc, value) => {
    const attrs = value.split(/\s+/);
    acc[attrs[0]] = attrs[0] + "-access";
    acc[attrs[2]] = attrs[2] + "-net";
    return acc;
  }, {});
};

